import { useState, useEffect } from 'react';

export interface IInputControlledProps {
  checked?: boolean;
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  id?: string;
  dataId?: number;
}

const InputControlled: React.FC<IInputControlledProps> = ({ checked, name, onChange, value, id, dataId }) => {
  const [isChecked, setIsChecked] = useState(!!checked);

  const updateChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(state => !state);
    onChange(e);
  };

  useEffect(() => {
    if (checked === undefined) return;
    setIsChecked(checked);
  }, [checked, dataId]);

  return (
    <>
      <input type="checkbox" id={id} name={name} onChange={updateChecked} value={value} checked={isChecked} />
    </>
  );
};

InputControlled.displayName = 'InputControlled';

export default InputControlled;
